import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams,useLocation, Link } from "react-router-dom";
import backImgBlack from "../../assets/images/back.svg";
import backImgBlackWhite from "../../assets/images/back-white-arrow.svg";
import GoogleMapComponent from "../../components/map/google-map.component";
import Slider from "react-slick";
import NoImage from "../../assets/images/no-image.svg";
import children from "../../assets/images/Children.svg";
import couples from "../../assets/images/Couples.svg";
import pregWomen from "../../assets/images/Pregnant women.svg";
import Scholarships from "../../assets/images/Scholarship.svg";
import serviceDogs from "../../assets/images/Service Dogs.svg";
import tickMarkIcon from "../../assets/images/tick-mark.svg";
import NoImageDetail from "../../assets/images/No-image-details-screen.svg";
import showAll from "../../assets/images/show-all.svg";
import pinImg from "../../assets/images/ic_pin_small.svg";
import starImg from "../../assets/images/star-24px.svg";
import HostReply from "../common/HostReply";
import { phpAction } from "../../actions/index";
import { useSelector, useDispatch } from "react-redux";
import { SpinnerContext } from "../../components/spinner/spinner.component";
import {
  addCommasToPrice,
  formatCamelCaseToReadabcommonAmenities,
  formatCamelCaseToReadableadditionaservices,
  formatCamelCaseToReadableadditionaservicesforPHP,
  formatCamelCaseToReadableassessmentPretreatment,
  formatCamelCaseToReadableinsurance,
  formatCamelCaseToReadablemedication,
  formatCamelCaseToReadableteamconsists,
  formatCamelCaseToReadabletreatmentapproaches,
  formatTestKeyToReadableiopphp,
} from "../../constants/utils";

import virtualTourIcon from "../../assets/images/virtual-tour.svg";
import aboutTitle from "../../../src/assets/images/aboutTitle.svg";
import phoneOrangeIcon from "../../../src/assets/images/call.svg";
import stayRange from "../../../src/assets/images/Range of term of stay.svg";
import maxCapacity from "../../../src/assets/images/Maximum capacity.svg";
import specializesIcon from "../../../src/assets/images/specializes-in.svg";
import servicesOfferedIcon from "../../../src/assets/images/additional-services-offered.svg";
import commonAmenities from "../../../src/assets/images/Common Amenities.svg";
import clientToClinical from "../../../src/assets/images/Client to clinical team ratio.svg";
import primaryLanguage from "../../../src/assets/images/Primary language.svg";
import otherLanguages from "../../../src/assets/images/Other languages.svg";
import genderTypeIcon from "../../../src/assets/images/gender-type.svg";
import conditionsIcon from "../../../src/assets/images/conditions-treated.svg";
import medicationIcon from "../../../src/assets/images/medication-therapy.svg";
import approachesIcon from "../../../src/assets/images/treatment-approaches.svg";
import assessmentIcon from "../../../src/assets/images/assessment-pre-treatment.svg";
import testingIcon from "../../../src/assets/images/testing.svg";
import smokingIcon from "../../../src/assets/images/facility-smoking-policy.svg";
import staffIcon from "../../../src/assets/images/staff-associated.svg";
import insuranceIcon from "../../../src/assets/images/insurance-accepted.svg";
import Viewshowmorebutton from "../../components/button/Viewshowmorebutton";
import ClaimFacility from "../home/claimFacilityView";
import Questions from "../../components/viewField/questions.component";
import AdTracker from "../../components/cards/AdTracker";
import AdTrackerConfirmationModel from "../../components/modal/AdTrackerConfirmationModel";
import ErrorModal from "../../components/modal/ErrorModal";
import SuccessModal from "../../components/modal/SuccessModal";
import AdTrackerButton from "../../components/button/AdTrackerButton";
import AdTrackerMobile from "../../components/cards/AdTrackerMobile";
import TopUpRechargeModel from "../../components/modal/TopUpRechargeModel";
import Breadcrumb from "../../components/breadcrumb/breadcrumb";

const PhpDetails = () => {
  const comp = useParams();
  const location = useLocation();
  
  const { showLoader, hideLoader } = useContext(SpinnerContext);
  const phpdetail = useSelector((state) => state?.php?.phpdetail);
  const phpLoading = useSelector((state) => state?.php?.phpLoading);

  const dispatch = useDispatch();
  const [GetData, setGetData] = useState([]);
  const [showmodel, setshowmodel] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });
  const [mainImage, setMainImage] = useState("");
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isAdTrackerModalVisible, setAdTrackerModalVisible] = useState(false);
  const [isTopUpModalVisible, setTopUpModalVisible] = useState(false);
  

  useEffect(() => {
    ShowData(comp?.id);
  }, [comp?.id]);

  const ShowData = async (id) => {
    showLoader("Geting Php center please wait ");
    const data = await dispatch(phpAction.getPhpById(id));
    document.title = data?.name;
    if(data?.photos?.length > 0) {
      setMainImage(data?.photos[0].path)
    }
    setGetData(data);

    setCoordinates({
      lat: data?.coordinates?.lat,
      lng: data?.coordinates?.lat,
    });
    hideLoader("");
  };
  var gallerySlider = {
    dots: true,
    infinite: false,
    speed: 300,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    swipeToSlide: true,
    afterChange: (current) => setCurrentSlide(current),
  };

  const formatPhoneNumber = (input) => {
    const phoneNumber = input?.replace(/\D/g, "");
    if (!phoneNumber) return "";

    let formattedPhoneNumber = `(${phoneNumber.slice(0, 3)})`;
    if (phoneNumber.length > 3) {
      formattedPhoneNumber += `-${phoneNumber.slice(3, 6)}-`;
    }
    if (phoneNumber.length > 6) {
      formattedPhoneNumber += `${phoneNumber.slice(6, 10)}`;
    }
    if (phoneNumber.length > 10) {
      formattedPhoneNumber += `-${phoneNumber.slice(10, 15)}`;
    }

    return formattedPhoneNumber;
  };

  // Inside the PhpDetails component, add these state variables and functions
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Add these functions to handle PPC actions
  const handlePauseClick = () => {
    setActionType("pause");
    setIsConfirmModalOpen(true);
  };

  const handleCancelClick = () => {
    setActionType("cancel");
    setIsConfirmModalOpen(true);
  };

  const toggleAdTrackerModal = () => {
    setAdTrackerModalVisible(!isAdTrackerModalVisible);
  };

  const confirmAction = async () => {
    setIsLoading(true);
    try {
      if (actionType === "pause") {

        const { ppcSubscriptionDetail } = GetData || {};  // Destructure GetData first

        const {adSpendForThisMonth,ppcAllocatedBudget,isPaused,topUpRemaining} = ppcSubscriptionDetail || {};  // Destructure ppcSubscriptionDetail safely

        if (adSpendForThisMonth >= ppcAllocatedBudget && topUpRemaining===0 ) {

          setTopUpModalVisible(true);
          return;

        }

        // Toggle the isPaused state
        const newIsPausedState = !isPaused;

        await dispatch(phpAction.onPhpPause(comp?.id, newIsPausedState));
      } else {
        const data = await dispatch(phpAction.onPhpCancel(comp?.id));

        if (data?.error) {
          setIsError(true);
          setErrorMessage(data?.error);
          return; // Exit the function if there is an error
        }

       if(data?.data){
        setIsConfirmModalOpen(false);
        const successMessage = data?.data || "Subscription cancelled successfully"; // Fallback message if API doesn't return one
        setIsSuccess(true);
        setSuccessMessage(successMessage); // Display success message from API
       }

     

      }
      const data = await dispatch(phpAction.getPhpById(comp?.id));
      setGetData(data);
    } catch (error) {
      setErrorMessage("An unexpected error occurred. Please try again later.");
      setIsError(true); // Show the toast
    } finally {
      setIsLoading(false);
      setIsConfirmModalOpen(false);
    }
  };

  const { isPPCActive } = GetData?.ppcSubscriptionDetail || {};
  const breadcrumbTitle = 'Profile';
  const breadcrumbPath = `/profile`;
  const linkPath = `/owner/facility/phpfacility/view/${GetData?.id}`;
  const breadcrumbItems = [
    { label: 'Home', path: '/' },
    { label: breadcrumbTitle, path: breadcrumbPath },
    { label: GetData?.name, path: linkPath, type: 'facility' },
  ];


  return (
    <>
      <Breadcrumb items={breadcrumbItems} />
      <section className="form-view-banner">
        <div className="banner-image">
          { mainImage!=="" ? (
            <React.StrictMode>
              <img src={mainImage} className="img-fluid" alt={GetData?.name} />
            </React.StrictMode>
          ) : (
            <img src={NoImageDetail} className="img-fluid" alt="NoImageDetail" />
          )}
        </div>
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-md-12 h-100">
              <div className="photos-banner-content d-flex flex-column justify-content-between h-100">
                <Link to="/profile" role="button" className="form-view-back">
                  <img src={backImgBlackWhite} className="img-fluid" alt="back-btn" />
                </Link>
                {GetData?.photos?.length !== 0 && (
                  <div className="show-all-photos w-100 text-right">
                    <button
                      type="button"
                      onClick={() => setshowmodel(true)}
                      className="btn btn-default d-flex align-items-center radius-20 m-0 ml-auto"
                    >
                      {" "}
                      <img src={showAll} className="img-fluid" alt="showAll" />
                      Show all Photos
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="form-view-tabs-sec with-subscription-plan pt-0">
        <div className="form-view-content">
          <div className="form-view-top position-relative">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="facility-content d-flex flex-wrap justify-content-center justify-content-md-between pt-md-4">
                    <div className="facility-info pt-md-3">
                      <h1 className="mt-0">
                        {GetData?.name
                          ?.split(" ")
                          ?.map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase()
                          )
                          .join(" ")}
                          {" "}
                          {GetData?.isVerified && (
                            <img
                            src={tickMarkIcon}
                            className="img-fluid"
                            alt="tickMarkIcon"
                                                    />
                                                  )}
                      </h1>
                      <span className="location">
                        <img src={pinImg} className="img-fluid m-0" alt={GetData?.name} />
                        {GetData?.geocodingResult?.cityName}
                        {", "}
                        {GetData?.geocodingResult?.stateShort}
                        {", "}
                        {GetData?.geocodingResult?.country}
                      </span>
                      {(GetData?.rentRange?.from || GetData?.rentRange?.to) && (
                        <span className="location">
                          {/* <img src={usdIcon} className="img-fluid m-0" alt="" /> */}
                          ${addCommasToPrice(GetData?.rentRange?.from)} - $
                          {addCommasToPrice(GetData?.rentRange?.to)}
                        </span>
                      )}
                      {(GetData?.preSalePlanType === "pro" ||
                        GetData?.subscriptionDetail?.subscriptionType ===
                          "pro" ||
                        GetData?.subscriptionDetail?.subscriptionType ===
                          "basic") && (
                        <span className="location">
                          <img src={starImg} className="img-fluid m-0" alt="starImg" />
                          {GetData?.rating?.value !== 0 ? (
                            <>
                              <span>{GetData?.rating?.value?.toFixed(1)}</span>
                            </>
                          ) : (
                            <>
                              <span>0.0</span>
                            </>
                          )}
                        </span>
                      )}
                    </div>
                    <div className="info-icon pt-2 pt-md-3">
                      <div className="container">
                        <div className="row">
                          <div className="col-md-12">
                            <a
                              href="#"
                              className="d-none d-md-block text-right"
                            ></a>
                            <div className="ad-tracker-wrapper d-flex flex-wrap align-items-center justify-content-center">

                            {(GetData?.isClaimRequest ||
                              GetData?.isSubscribed ||
                              GetData?.isPreSaleSubscribed) && (
                              <ClaimFacility
                                facilityId={GetData?.id}
                                Facilityname={GetData?.name}
                                dashboard="yes"
                                flag={
                                  GetData?.isSubscribed ||
                                  GetData?.isPreSaleSubscribed
                                }
                              />
                            )}
                             {/* Mobile-only AdTracker button */}
                                                                                   
                              {isPPCActive && <AdTrackerButton onClick={toggleAdTrackerModal} />}
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="active-plan mt-4 mb-5">
            <div className="container">
              <div className="plan-wrp">
                {GetData?.isPreSaleSubscribed || GetData?.isSubscribed ? (
                  <div className="plan-wrp">
                    <img
                      src={require("../../assets/images/email-marketing.svg")}
                      className="mr-3"
                      alt={GetData?.name}
                    />
                    <div className="plan-content">
                      <span>
                        Active Plan{" "}
                        {GetData?.preSalePlanType === "basic" ||
                        GetData.subscriptionDetail?.subscriptionType === "basic"
                          ? "Basic"
                          : "Pro"}
                      </span>
                      {GetData?.preSalePlanType && (
                        <h3>
                          ${GetData?.preSalePlanType === "basic" ? 19 : 39}{" "}
                        </h3>
                      )}
                      {GetData?.isSubscribed && (
                        <div>
                          <span>${GetData.subscriptionDetail?.price}</span>
                          {"   /  "}
                          <span>
                            {GetData.subscriptionDetail?.interval == "month"
                              ? "Monthly"
                              : "Yearly"}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="plan-wrp">
                    <img
                      src={require("../../assets/images/Subscription pending icon.svg")}
                      className="mr-3"
                      alt="Subscriptionicon"
                    />
                    <div className="plan-content">
                      {" "}
                      <span className="mb-0">
                        Subscription pending. Subscribe your facility to get
                        listed on the homepage.
                      </span>{" "}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="form-view-detail">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="facility-content">
                    <div className="row">
                      <div className="col-md-8">
                        <div className="about-content pt-0 pb-2">
                          {GetData?.about && (
                            <h2 className="d-flex align-items-center mt-0">
                              <img src={aboutTitle} className="img-fluid" alt="aboutTitle" />{" "}
                              {GetData?.aboutHeader ? GetData.aboutHeader : "About"}
                            </h2>
                          )}

                          <p>{GetData?.about}</p>
                          {GetData?.webUrl !== "https://www." && (
                            <div
                              className="about-list"
                          onClick={() => window.open(GetData?.webUrl, "_blank")}
                            >
                              <div className="about-link">
                                <img
                                  src={virtualTourIcon}
                                  sizes="20px"
                                  className="img-fluid"
                                  alt="virtualTourIcon"
                                />{" "}
                                <span>{GetData?.webUrl}</span>
                              </div>
                            </div>
                          )}
                          {GetData?.phoneNumber && (
                            <div
                              className="about-list"
                              onClick={() =>
                                (window.location.href = `tel:${GetData?.phoneNumber}`)
                              }
                            >
                              <div className="about-link">
                                <img
                                  src={phoneOrangeIcon}
                                  sizes="20px"
                                  className="img-fluid"
                                  alt="phoneOrangeIcon"
                                />{" "}
                                <span>
                                  {formatPhoneNumber(GetData?.phoneNumber)}
                                </span>
                              </div>
                            </div>
                          )}
                          <div className="about-list">
                        {GetData?.subscriptionDetail?.subscriptionType === "pro"
                              ? GetData?.virtualHouseLink && (
                                  <>
                                {GetData.virtualHouseLink !== "https://www." &&
                                      GetData.virtualHouseLink !== "" &&
                                      GetData.virtualHouseLink !==
                                        "http://www." && (
                                        <div
                                          className="about-link"
                                          onClick={() =>
                                            window.open(
                                              GetData?.virtualHouseLink,
                                              "_blank"
                                            )
                                          }
                                        >
                                          <img
                                            src={virtualTourIcon}
                                            sizes="20px"
                                            className="img-fluid"
                                            alt="virtualTourIcon"
                                          />
                                      <span>{GetData.virtualHouseLink}</span>
                                        </div>
                                      )}
                                  </>
                                )
                              : ""}
                          </div>
                        </div>
                        <h3 className="mt-2">Location</h3>
                        <span className="location">
                      <img src={pinImg} className="img-fluid m-0" alt="location" />
                          {GetData?.geocodingResult?.cityName}
                          {", "}
                          {GetData?.geocodingResult?.stateShort}
                          {", "}
                          {GetData?.geocodingResult?.country}
                        </span>
                      </div>
                      {/* Right column (col-4) for AdTracker */}
                      <div className="col-md-4">

                      <AdTrackerMobile
                          isAdTrackerModalVisible={isAdTrackerModalVisible}
                          toggleAdTrackerModal={toggleAdTrackerModal}
                          ppcSubscriptionDetail={GetData?.ppcSubscriptionDetail}
                          onPauseClick={handlePauseClick}
                          onCancelClick={handleCancelClick}
                          isLoading={phpLoading || isLoading}
                        />
                      
                        <AdTracker
                          ppcSubscriptionDetail={GetData?.ppcSubscriptionDetail}
                          onPauseClick={handlePauseClick}
                          onCancelClick={handleCancelClick}
                          isLoading={phpLoading || isLoading}
                        />
                    
                      </div>
                    </div>
                    <div className="map-view form-group mt-3 pt-1">
                      <GoogleMapComponent
                        className="details-map"
                        markers={[phpdetail?.coordinates || { lat: 0, lng: 0 }]}
                        newCenter={{
                          lat: phpdetail?.coordinates?.lat
                            ? phpdetail?.coordinates?.lat
                            : 0,
                          lng: phpdetail?.coordinates?.lng
                            ? phpdetail?.coordinates?.lng
                            : 0,
                        }}
                        handleClick={(e) => {
                          setCoordinates({ lat: e.lat, lng: e.lng });
                        }}
                      />
                    </div>
                  </div>
                  {(GetData?.allowableStay?.from ||
                    GetData?.allowableStay?.to) && (
                    <div className="facility-content">
                      <h3 className="d-flex align-items-center">
                        {" "}
                        <img src={stayRange} className="img-fluid" alt="stayRange" />
                        Range of Term Of Stay{" "}
                      </h3>
                      <ul className="d-flex align-items-start flex-wrap">
                        <li>
                          {GetData?.allowableStay?.from} days -{" "}
                          {GetData?.allowableStay?.to} days
                        </li>
                      </ul>
                    </div>
                  )}

                  {GetData?.maximumCapacity !== 0 &&
                    GetData?.maximumCapacity !== null && (
                      <div className="facility-content">
                        <h3 className="d-flex align-items-center">
                          <img src={maxCapacity} className="img-fluid" alt="maxCapacity" />
                          Maximum Capacity
                        </h3>
                        <ul className="d-flex align-items-start flex-wrap">
                          <li>{GetData?.maximumCapacity}</li>
                        </ul>
                      </div>
                    )}

                  {GetData?.specialization && (
                    <Viewshowmorebutton
                      GetData={GetData?.specialization}
                      iocn={specializesIcon}
                      name="Specialize In"
                    />
                  )}
                  {GetData?.additionalServiceOffered &&
                    Object.values(GetData?.additionalServiceOffered).some(
                      (value) => value === true
                    ) && (
                      <div className="facility-content">
                        <h3 className="d-flex align-items-center">
                          <img
                            src={servicesOfferedIcon}
                            className="img-fluid"
                            alt="servicesOfferedIcon"
                          />
                          Additional Services Offered
                        </h3>
                        <ul className="d-flex align-items-start flex-wrap">
                          {GetData?.additionalServiceOffered &&
                            Object.entries(
                              GetData?.additionalServiceOffered
                            )?.map(([key, value]) => {
                              if (value) {
                                return (
                                  <li key={key}>
                                    {formatCamelCaseToReadableadditionaservices(
                                      key
                                    )}
                                  </li>
                                );
                              } else {
                                return null;
                              }
                            })}
                        </ul>
                      </div>
                    )}

                  {GetData?.personalAmenities && (
                    <Viewshowmorebutton
                      GetData={GetData?.personalAmenities}
                      iocn={commonAmenities}
                      name="Personal Amenities"
                    />
                  )}
                  {GetData?.commonAmenities && (
                    <Viewshowmorebutton
                      GetData={GetData?.commonAmenities}
                      iocn={commonAmenities}
                      name="Common Amenities"
                    />
                  )}

                  {GetData?.primaryLanguage != "" &&
                    GetData?.primaryLanguage !== null && (
                      <div className="facility-content">
                        <h3 className="d-flex align-items-center">
                          <img
                            src={primaryLanguage}
                            className="img-fluid"
                            alt="primaryLanguage"
                          />
                          Primary language
                        </h3>
                        <ul className="d-flex align-items-start flex-wrap">
                          <li>
                            {GetData?.primaryLanguage &&
                              GetData.primaryLanguage.charAt(0).toUpperCase() +
                                GetData.primaryLanguage.slice(1)}
                          </li>
                        </ul>
                      </div>
                    )}

                  {GetData?.isOfferedOtherlanguages &&
                    GetData?.otherlanguages?.length !== 0 &&
                    phpdetail?.otherlanguages?.length !== 0 && (
                      <div className="facility-content">
                        <h3 className="d-flex align-items-center">
                          <img
                            src={otherLanguages}
                            className="img-fluid"
                            alt="otherLanguages"
                          />
                          Other Languages
                        </h3>
                        <ul className="d-flex align-items-start flex-wrap">
                          {GetData?.otherlanguages?.map((language, key) => (
                            <li key={key}>
                              {formatCamelCaseToReadabcommonAmenities(language)}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                  {GetData?.genderSpecific === true &&
                    GetData?.gender !== "anybody" &&
                    GetData.gender !== "anybody" && (
                      <div className="facility-content">
                        <h3 className="d-flex align-items-center">
                          <img
                            src={genderTypeIcon}
                            className="img-fluid"
                            alt="genderTypeIcon"
                          />
                          Gender Type
                        </h3>
                        <ul className="d-flex align-items-start flex-wrap">
                          <li>
                            {GetData?.gender === "men"
                              ? "Male"
                              : "" || GetData?.gender === "women"
                              ? "Female"
                              : "" || GetData?.gender === "lgbtq"
                              ? "LGBTQ"
                              : ""}
                          </li>
                        </ul>
                      </div>
                    )}

                  {GetData?.conditionTreated &&
                    Object.values(GetData?.conditionTreated).some(
                      (value) => value === true
                    ) && (
                      <Viewshowmorebutton
                        GetData={GetData?.conditionTreated}
                        iocn={conditionsIcon}
                        name="Conditions Treated"
                      />
                    )}
                  {GetData?.medicationTherapy &&
                    Object.values(GetData?.medicationTherapy).some(
                      (value) => value === true
                    ) && (
                      <div className="facility-content">
                        <h3 className="d-flex align-items-center">
                          <img
                            src={medicationIcon}
                            className="img-fluid"
                            alt="medicationIcon"
                          />
                          Medication Therapy
                        </h3>
                        <ul className="d-flex align-items-start flex-wrap">
                          {GetData?.medicationTherapy &&
                            Object.entries(GetData?.medicationTherapy)?.map(
                              ([key, value]) => {
                                if (value) {
                                  const formattedKey = key;
                                  return (
                                    <li key={key}>
                                      {formatCamelCaseToReadablemedication(
                                        formattedKey
                                      )}
                                    </li>
                                  );
                                } else {
                                  return null;
                                }
                              }
                            )}
                        </ul>
                      </div>
                    )}

                  {GetData?.treatmentApproaches &&
                    Object.values(GetData?.treatmentApproaches).some(
                      (value) => value === true
                    ) && (
                      <Viewshowmorebutton
                        GetData={GetData?.treatmentApproaches}
                        iocn={approachesIcon}
                        name="Treatment Approaches"
                        formatstring={
                          formatCamelCaseToReadabletreatmentapproaches
                        }
                      />
                    )}

                  {GetData?.preTreatment &&
                    Object.values(GetData?.preTreatment).some(
                      (value) => value === true
                    ) && (
                      <div className="facility-content">
                        <h3 className="d-flex align-items-center">
                          <img
                            src={assessmentIcon}
                            className="img-fluid"
                            alt="assessmentIcon"
                          />
                          Assessment/ Pre-treatment
                        </h3>
                        <ul className="d-flex align-items-start flex-wrap">
                          {GetData?.preTreatment &&
                            Object.entries(GetData?.preTreatment)?.map(
                              ([key, value]) => {
                                if (value) {
                                  const formattedKey = key;
                                  return (
                                    <li key={key}>
                                      {formatCamelCaseToReadableassessmentPretreatment(
                                        formattedKey
                                      )}
                                    </li>
                                  );
                                } else {
                                  return null;
                                }
                              }
                            )}
                        </ul>
                      </div>
                    )}

                  {GetData?.testing &&
                    Object.values(GetData?.testing).some(
                      (value) => value === true
                    ) && (
                      <div className="facility-content">
                        <h3 className="d-flex align-items-center">
                          <img src={testingIcon} className="img-fluid" alt="testingIcon" />
                          Testing
                        </h3>
                        <ul className="d-flex align-items-start flex-wrap">
                          {GetData?.testing &&
                            Object.entries(GetData?.testing)?.map(
                              ([key, value]) => {
                                if (value) {
                                  const formattedKey =
                                    formatTestKeyToReadableiopphp(key);

                                  return <li key={key}>{formattedKey}</li>;
                                } else {
                                  return null;
                                }
                              }
                            )}
                        </ul>
                      </div>
                    )}

                  {GetData?.smokingPolicy &&
                    Object.values(GetData?.smokingPolicy).some(
                      (value) => value === true
                    ) && (
                      <div className="facility-content">
                        <h3 className="d-flex align-items-center">
                          <img src={smokingIcon} className="img-fluid" alt="smokingIcon" />
                          Facility Smoking Policy
                        </h3>
                        <ul className="d-flex align-items-start flex-wrap">
                          {GetData?.smokingPolicy &&
                            Object.entries(GetData?.smokingPolicy)?.map(
                              ([key, value]) => {
                                if (value) {
                                  const formattedKey = key;
                                  return (
                                    <li key={key}>
                                      {formatTestKeyToReadableiopphp(
                                        formattedKey
                                      )}
                                    </li>
                                  );
                                } else {
                                  return null;
                                }
                              }
                            )}
                        </ul>
                      </div>
                    )}

                  <Questions
                    image={serviceDogs}
                    heading="Allows Service Dogs"
                    details={GetData?.serviceDogs}
                  />
                  <Questions
                    image={couples}
                    heading="Allows Couples"
                    details={GetData?.couples}
                  />
                  <Questions
                    image={pregWomen}
                    heading="Allows Pregnant Women"
                    details={GetData?.pregnantWomen}
                  />
                  <Questions
                    image={children}
                    heading="Allows Children"
                    details={GetData?.children}
                  />
                  <Questions
                    image={Scholarships}
                    heading="Offers Scholarships"
                    details={GetData?.offersScholarships}
                  />

                  {GetData?.teamConsist &&
                    Object.values(GetData?.teamConsist).some(
                      (value) => value === true
                    ) && (
                      <div className="facility-content">
                        <h3 className="d-flex align-items-center">
                          <img src={staffIcon} className="img-fluid" alt="staffIcon" />
                          Staff Associated
                        </h3>
                        <ul className="d-flex align-items-start flex-wrap">
                          {GetData?.teamConsist &&
                            Object.entries(GetData?.teamConsist)?.map(
                              ([key, value]) => {
                                if (value) {
                                  return (
                                    <li key={key}>
                                      {formatCamelCaseToReadableteamconsists(
                                        key
                                      )}
                                    </li>
                                  );
                                } else {
                                  return null;
                                }
                              }
                            )}
                        </ul>
                      </div>
                    )}
                  {GetData?.clients && GetData?.clinical && (
                    <div className="facility-content">
                      <h3 className="d-flex align-items-center">
                        <img
                          src={clientToClinical}
                          className="img-fluid"
                          alt="clientToClinical"
                        />
                        Client To Clinical Team Ratio
                      </h3>
                      <ul className="d-flex align-items-start flex-wrap">
                        <li>
                          {GetData?.clients}{" "}
                          {GetData?.clients === 1 ? "Client" : "Clients"} :{" "}
                          {GetData?.clinical}{" "}
                          {GetData.clinical === 1 ? "Clinician" : "Clinicians"}{" "}
                        </li>
                      </ul>
                    </div>
                  )}

                  {GetData?.insurance &&
                    Object.values(GetData?.insurance).some(
                      (value) => value === true
                    ) && (
                      <div className="facility-content">
                        <h3 className="d-flex align-items-center">
                          <img
                            src={insuranceIcon}
                            className="img-fluid"
                            alt="insuranceIcon"
                          />
                          Insurance Accepted
                        </h3>
                        <ul className="d-flex align-items-start flex-wrap">
                          {GetData?.insurance &&
                            Object.entries(GetData?.insurance)?.map(
                              ([key, value]) => {
                                if (value) {
                                  return (
                                    <li key={key}>
                                      {formatCamelCaseToReadableinsurance(key)}
                                    </li>
                                  );
                                } else {
                                  return null;
                                }
                              }
                            )}
                        </ul>
                      </div>
                    )}

                  <button
                    type="button"
                    className="btn btn-primary radius-20 m-0 px-4 mt-4"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(`${GetData?.verifyInsurance}`, "_blank");
                    }}
                    disabled={
                      GetData?.verifyInsurance?.trim() === "" ||
                      GetData?.verifyInsurance?.trim() === "https://www."
                    }
                  >
                    Verify Insurance
                  </button>

                  <HostReply chatid={comp?.id} type="php" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <>
        {showmodel && (
          <div
            className={`modal fade photo-gallery-modal ${
              showmodel ? "show d-block" : ""
            }`}
            id="exampleModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="gallery-content">
                  <div className="modal-header border-0 p-0">
                    <div className="modal-header-top d-flex w-100 align-items-center">
                      <a role="button" className="d-block d-md-none">
                        <img src={backImgBlack} alt="back-btn" />
                      </a>
                      <a
                        className="cancel-btn d-flex align-items-center"
                        role="button"
                        onClick={() => setshowmodel(false)}
                      >
                        <img
                          src={require("../../assets/images/cancle.svg")}
                          className="img-fluid"
                          alt="close-btn"
                        />{" "}
                        Close
                      </a>
                      {/* <div className="pagination">
                        {currentSlide + 1} / {GetData?.photos?.length}
                      </div> */}
                    </div>
                  </div>
                  <Slider {...gallerySlider} className="gallery-slider">
                    {GetData?.photos?.map((obj) => {
                      return (
                        <>
                          <div className="slider-item">
                            <img src={obj?.path} className="img-fluid" alt={GetData?.name} />
                            {/* <h3>{GetData?.name} Room</h3> */}
                          </div>
                        </>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        )}
      </>

      {/* Top-Up Recharge Modal */}
      <TopUpRechargeModel
        isOpen={isTopUpModalVisible}
        propertydata={GetData}
        redirectUrl={location.pathname}
        onCancel={() => setTopUpModalVisible(false)} // Close modal on cancel
      />

      {/* Success Modal */}
      <SuccessModal
        isSuccess={isSuccess}
        successMessage={successMessage}
        onClose={() => setIsSuccess(false)} // Close on success modal close
      />

      <ErrorModal
        isError={isError}
        errorMessage={errorMessage}
        onClose={() => setIsError(false)} // Close modal
      />

      <AdTrackerConfirmationModel
      isOpen={isConfirmModalOpen}
      actionType={actionType}
      ppcSubscriptionDetail={GetData?.ppcSubscriptionDetail}
      onCancel={() => setIsConfirmModalOpen(false)}
      onConfirm={confirmAction}
      isLoading={phpLoading || isLoading}
      />
    </>
  );
};

export default PhpDetails;
